import { useEffect, useState } from 'react';
import { FluxCard, FluxNavigationCard, FluxTooltip } from '@meltwater/flux-web-components-react';
import { useNavigate } from 'react-router-dom';
import { useCompanyId } from '../../services/CompanyidProvider';
import styles from './FluxAppCard.module.css';

const FluxAppCard = (props) => {
  const { companyId } = useCompanyId();
  const [disablerequire, setdisableRequire] = useState('');
  const navigate = useNavigate();
  const navigateToRoute = (targetroute) => {
    
    //todo Undo this and add the corect state
    if (disablerequire === '#ff0000')
    {
        window.alert("CompanyID is required");
    }
    else
    {
    // Replace '/target-route' with the path of the route you want to navigate to
    if(props.href.includes("https:"))
    {
      window.open(props.href, '_blank');
    }
    else{
    navigate(`${targetroute}`);
    }
  }
  }
  
  useEffect(() => {
    let NewStatus = "#33aa44";
    if (props.required && props.required.includes('companyid')) {
     
      if ((companyId.length < 6))  {
     
        NewStatus = "#ff0000"
      }
      
      setdisableRequire(NewStatus)
    }
    if (!props.required){
      setdisableRequire("#33aa44")
    }
  }, [companyId,props.required])

  const handleKeyDown = (event) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      navigateToRoute(props.href);
    }
  };

  if (props.iconSrc) {
    return (
      <>
        <FluxCard
          className={styles.customCard}
          onClick={() => navigateToRoute(props.href)}
          onKeyDown={handleKeyDown}
          role="button"
          tabIndex={0}
          aria-label={`Open ${props.title}`}
        >
          <div className={styles.cardRow}>
            <span className={styles.halo} style={{ color: disablerequire }}>
              <span
                className={styles.haloMask}
                style={{
                  WebkitMaskImage: `url(${props.iconSrc})`,
                  maskImage: `url(${props.iconSrc})`,
                }}
              />
            </span>
            <div className={styles.textColumn}>
              <div className={styles.cardTitle}>{props.title}</div>
              {props.text && <div className={styles.cardInfo}>{props.text}</div>}
            </div>
          </div>
          <FluxTooltip placement='top'> {`Open ${props.title}`}</FluxTooltip>
        </FluxCard>
      </>
    );
  }

  return (
    <>
      <FluxNavigationCard
        dense
        cardTitle={props.title}
        card-dense-info={props.text}
        haloIconName={props.startIcon}
        haloIconColor={disablerequire}
        onFlux-trigger-primary={(() => { navigateToRoute(props.href); })}
      >
        <FluxTooltip placement='top'> {`Open ${props.title}`}</FluxTooltip>
      </FluxNavigationCard>
    </>
  );
};


FluxAppCard.propTypes = {};

FluxAppCard.defaultProps = {};

export default FluxAppCard;
